import httpClient from '../../services/http-client';
import { API_SUB_URL_MEDICINE, API_SUB_URL_MEDICINE_IMPORT_EXPORT, API_SUB_URL_EXPORT_CSV_FILE, API_SUB_URL_EXPORT_EXCEL_FILE } from '../../constants';
import { fetchDataRequest, fetchDataSuccess, fetchDataError } from '../actions';
import { 
    FETCH_DATA_REQUEST, FETCH_DATA_ERROR,
    ADD_NEW_MEDICINE, LOAD_LIST_MEDICINE, LOAD_A_MEDICINE, UPDATE_A_MEDICINE, DELETE_A_MEDICINE,
    ADD_NEW_MEDICINE_IMPORT_EXPORT, LOAD_LIST_MEDICINE_IMPORT_EXPORT, LOAD_A_MEDICINE_IMPORT_EXPORT, 
    UPDATE_A_MEDICINE_IMPORT_EXPORT, DELETE_A_MEDICINE_IMPORT_EXPORT, UPDATE_LIST_MEDICINE_WHEN_IMPORT_EXPORT,
    DOC_EXPORT_MEDICINE_LIST_TO_CSV, DOC_EXPORT_MEDICINE_LIST_TO_EXCEL
} from '../actionTypes';

export const apiLoadListMedicine = (params) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        let query = "";
        
        Object.keys(params).map(key => {
            if(params[key]) {
                query += (query.length > 0 ? "&&" : "") + (`${key}=` + params[key]);
            }
        });

        httpClient.get(`${API_SUB_URL_MEDICINE}?${query}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_MEDICINE, response.data));
            })
            .catch(error => {
                console.log("--- error", error)
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiLoadAMedicine = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.get(`${API_SUB_URL_MEDICINE}/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_A_MEDICINE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewMedicine = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_MEDICINE, payload)
            .then(response => {
                dispatch(fetchDataSuccess(ADD_NEW_MEDICINE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAMedicine = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_MEDICINE}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_MEDICINE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAMedicine = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_MEDICINE}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_MEDICINE, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiExportMedicineListToCSV = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(DOC_EXPORT_MEDICINE_LIST_TO_CSV.LOADING));

        httpClient.post(`${API_SUB_URL_EXPORT_CSV_FILE}/medicines`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(DOC_EXPORT_MEDICINE_LIST_TO_CSV.SUCCESS, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(DOC_EXPORT_MEDICINE_LIST_TO_CSV.FAILURE, error))
            });
    }
};

export const apiExportMedicineListToExcel = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(DOC_EXPORT_MEDICINE_LIST_TO_EXCEL.LOADING));

        httpClient.post(`${API_SUB_URL_EXPORT_EXCEL_FILE}/medicines`, payload, {responseType: "blob"})
            .then(response => {
                dispatch(fetchDataSuccess(DOC_EXPORT_MEDICINE_LIST_TO_EXCEL.SUCCESS, response.data));
            })
            .catch(error => {
                
                dispatch(fetchDataError(DOC_EXPORT_MEDICINE_LIST_TO_EXCEL.FAILURE, error))
            });
    }
};

// Medicine Import Export
export const apiLoadListMedicineImportExportByMedicineId = ({ id }) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));
        httpClient.get(`${API_SUB_URL_MEDICINE_IMPORT_EXPORT}/medicines/${id}`)
            .then(response => {
                dispatch(fetchDataSuccess(LOAD_LIST_MEDICINE_IMPORT_EXPORT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiCreateNewMedicineImportExport = (payload) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.post(API_SUB_URL_MEDICINE_IMPORT_EXPORT, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_LIST_MEDICINE_WHEN_IMPORT_EXPORT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiUpdateAMedicineImportExport = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.put(`${API_SUB_URL_MEDICINE_IMPORT_EXPORT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(UPDATE_A_MEDICINE_IMPORT_EXPORT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};

export const apiDeleteAMedicineImportExport = ({id, payload}) => {
    return dispatch => {
        dispatch(fetchDataRequest(FETCH_DATA_REQUEST));

        httpClient.delete(`${API_SUB_URL_MEDICINE_IMPORT_EXPORT}/${id}`, payload)
            .then(response => {
                dispatch(fetchDataSuccess(DELETE_A_MEDICINE_IMPORT_EXPORT, response.data));
            })
            .catch(error => {
                dispatch(fetchDataError(FETCH_DATA_ERROR, error))
            });
    }
};